import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Search, Filter, BookOpen } from 'lucide-react';
const articles = [{
  id: 1,
  title: 'Cara Mengelola Stres untuk Remaja',
  category: 'Kesehatan Mental',
  excerpt: 'Masa remaja penuh dengan perubahan. Pelajari cara efektif mengelola stres agar tetap sehat mental dan fisik.',
  image: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?auto=format&fit=crop&q=80&w=800',
  link: 'https://www.halodoc.com/artikel/cara-mengelola-stres-pada-remaja',
  color: 'bg-pink-100 text-pink-700'
}, {
  id: 2,
  title: 'Mengenal Anxiety dan Cara Mengatasinya',
  category: 'Kesehatan Mental',
  excerpt: 'Merasa cemas berlebihan? Pahami apa itu anxiety dan langkah-langkah praktis untuk meredakannya.',
  image: 'https://images.unsplash.com/photo-1564121211835-e88c852648ab?auto=format&fit=crop&q=80&w=800',
  link: 'https://www.sehatq.com/artikel/cara-mengatasi-anxiety-disorder',
  color: 'bg-pink-100 text-pink-700'
}, {
  id: 3,
  title: 'Pentingnya Self-Care untuk Kesehatan Mental',
  category: 'Kesehatan Mental',
  excerpt: 'Self-care bukan egois, melainkan kebutuhan. Temukan cara sederhana merawat diri sendiri setiap hari.',
  image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=800',
  link: 'https://hellosehat.com/mental/stres/pentingnya-self-care/',
  color: 'bg-pink-100 text-pink-700'
}, {
  id: 4,
  title: 'Teknik Pomodoro untuk Belajar Efektif',
  category: 'Tips Belajar',
  excerpt: 'Sering hilang fokus saat belajar? Cobalah teknik Pomodoro untuk meningkatkan produktivitas belajarmu.',
  image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?auto=format&fit=crop&q=80&w=800',
  link: 'https://www.gramedia.com/literasi/teknik-pomodoro/',
  color: 'bg-blue-100 text-blue-700'
}, {
  id: 5,
  title: 'Cara Membuat Jadwal Belajar yang Efektif',
  category: 'Tips Belajar',
  excerpt: 'Manajemen waktu adalah kunci sukses. Pelajari cara menyusun jadwal belajar yang realistis dan efektif.',
  image: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&q=80&w=800',
  link: 'https://www.ruangguru.com/blog/cara-membuat-jadwal-belajar',
  color: 'bg-blue-100 text-blue-700'
}, {
  id: 6,
  title: 'Cara Mengatasi Bullying di Sekolah',
  category: 'Relasi Sosial',
  excerpt: 'Bullying tidak boleh dibiarkan. Ketahui cara menghadapi dan melaporkan tindakan bullying di lingkungan sekolah.',
  image: 'https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?auto=format&fit=crop&q=80&w=800',
  link: 'https://cerdasberkarakter.kemdikbud.go.id/stop-perundungan/',
  color: 'bg-green-100 text-green-700'
}, {
  id: 7,
  title: 'Tips Membangun Pertemanan yang Sehat',
  category: 'Relasi Sosial',
  excerpt: 'Lingkungan pertemanan sangat mempengaruhi perkembanganmu. Kenali ciri-ciri toxic friendship dan cara menghindarinya.',
  image: 'https://images.unsplash.com/photo-1529156069898-49953eb1b5ce?auto=format&fit=crop&q=80&w=800',
  link: 'https://www.halodoc.com/artikel/cara-membangun-hubungan-pertemanan-yang-sehat',
  color: 'bg-green-100 text-green-700'
}, {
  id: 8,
  title: 'Mengenal Jurusan Kuliah Populer 2024',
  category: 'Perencanaan Karier',
  excerpt: 'Bingung milih jurusan? Simak daftar jurusan kuliah yang paling banyak diminati dan prospek kerjanya.',
  image: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&q=80&w=800',
  link: 'https://kampusgratis.id/blog/jurusan-kuliah-populer',
  color: 'bg-purple-100 text-purple-700'
}, {
  id: 9,
  title: 'Tips Memilih Karier Sesuai Minat',
  category: 'Perencanaan Karier',
  excerpt: 'Jangan salah langkah. Panduan menemukan jalur karier yang sesuai dengan passion dan kemampuanmu.',
  image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=800',
  link: 'https://akupintar.id/info-pintar/-/blogs/cara-memilih-jurusan-kuliah-sesuai-minat-dan-bakat',
  color: 'bg-purple-100 text-purple-700'
}];
const categories = ['Semua', 'Kesehatan Mental', 'Tips Belajar', 'Relasi Sosial', 'Perencanaan Karier'];
export function Articles() {
  const [activeCategory, setActiveCategory] = useState('Semua');
  const [searchQuery, setSearchQuery] = useState('');
  const filteredArticles = articles.filter(article => {
    const matchesCategory = activeCategory === 'Semua' || article.category === activeCategory;
    const matchesSearch = article.title.toLowerCase().includes(searchQuery.toLowerCase()) || article.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  return <div className="bg-gray-50 min-h-screen py-12" data-id="element-185">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-187">
          <div className="inline-flex items-center justify-center p-3 bg-blue-100 rounded-full mb-4 text-blue-600" data-id="element-188">
            <BookOpen size={32} data-id="element-189" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-190">
            Artikel & Edukasi
          </h1>
          <p className="text-gray-600 text-lg" data-id="element-191">
            Temukan berbagai informasi bermanfaat untuk mendukung kesehatan
            mental, proses belajar, dan perencanaan masa depanmu.
          </p>
        </div>

        {/* Search and Filter */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-10" data-id="element-192">
          <div className="relative w-full md:w-96" data-id="element-193">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-194">
              <Search className="h-5 w-5 text-gray-400" data-id="element-195" />
            </div>
            <input type="text" className="block w-full pl-10 pr-3 py-3 border border-gray-200 rounded-xl leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-all shadow-sm" placeholder="Cari artikel..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-196" />
          </div>

          <div className="flex overflow-x-auto pb-2 md:pb-0 w-full md:w-auto gap-2 hide-scrollbar" data-id="element-197">
            {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-medium transition-all ${activeCategory === category ? 'bg-gradient-to-r from-pink-400 to-blue-400 text-white shadow-md' : 'bg-white text-gray-600 border border-gray-200 hover:bg-gradient-to-r hover:from-pink-50 hover:to-blue-50'}`} data-id="element-198">
                {category}
              </button>)}
          </div>
        </div>

        {/* Articles Grid */}
        {filteredArticles.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-199">
            {filteredArticles.map((article, index) => <motion.div key={article.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-lg transition-all flex flex-col h-full group" data-id="element-200">
                <div className="relative h-48 overflow-hidden" data-id="element-201">
                  <img src={article.image} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-202" />
                  <div className="absolute top-4 left-4" data-id="element-203">
                    <span className={`px-3 py-1 rounded-full text-xs font-bold ${article.color} shadow-sm`} data-id="element-204">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-6 flex flex-col flex-grow" data-id="element-205">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-primary transition-colors" data-id="element-206">
                    {article.title}
                  </h3>
                  <p className="text-gray-600 mb-6 line-clamp-3 text-sm flex-grow" data-id="element-207">
                    {article.excerpt}
                  </p>
                  <a href={article.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 w-full py-3 px-4 bg-gray-50 hover:bg-primary hover:text-white text-primary-dark rounded-xl font-semibold transition-colors mt-auto" data-id="element-208">
                    Baca Selengkapnya <ExternalLink size={16} data-id="element-209" />
                  </a>
                </div>
              </motion.div>)}
          </div> : <div className="text-center py-20 bg-white rounded-3xl border border-gray-100" data-id="element-210">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4" data-id="element-211">
              <Search className="h-8 w-8 text-gray-400" data-id="element-212" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-213">
              Artikel tidak ditemukan
            </h3>
            <p className="text-gray-500" data-id="element-214">
              Coba gunakan kata kunci lain atau ubah kategori pencarian.
            </p>
          </div>}
      </div>
    </div>;
}